import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { H3 } from 'partials/typography';
import { arrayFromRange } from 'helpers';
import { Checkbox, Select } from 'partials/formElements';
import InfoCard from 'partials/InfoCard';

import {
    setCalculatorYearBorn,
    setCalculatorAdditionalPoints,
} from 'store';

class AditionalPoints extends Component {

    _onSelectBirthYearDropdownChange(e) {
        this.props.setCalculatorYearBorn(e.target.value);
    }

    _onExtraPointsChackboxChange(e) {
        const { name, value } = e.target;
        const additionalPoints = { ...this.props.additionalPoints };

        if(!additionalPoints[name]) {
            additionalPoints[name] = Number(value);
        } else {
            delete additionalPoints[name];
        }

        this.props.setCalculatorAdditionalPoints(additionalPoints);
    }

    birtYearDropdownValues() {
        const currentYear = new Date().getFullYear();
        const from = currentYear - 103;
        const to = currentYear - 18;
        return arrayFromRange(from, to).reverse();
    }
  
    render() {
        const { yearBorn, additionalPoints } = this.props;

        return (
            <Wrapper>
                
                <Main>
                    <Intro>
                        <H3>Hvilket år er du født?</H3>
                    </Intro>

                    <Select 
                        value={yearBorn} 
                        label="Velg år"
                        className="year-select"
                        options={this.birtYearDropdownValues().map(year => ({ value: year, name: year }))} 
                        onChange={this._onSelectBirthYearDropdownChange.bind(this)} 
                    />

                    <ExtraPoints>
                        <ul>
                            <li>
                                <Checkbox 
                                    value="1" 
                                    checked={!!additionalPoints.passedService} 
                                    name="passedService" 
                                    label="Gjennomført førstegangstjenesten" 
                                    onChange={this._onExtraPointsChackboxChange.bind(this)} 
                                />
                            </li>
                            <li>
                                <Checkbox 
                                    value="1" 
                                    checked={!!additionalPoints.approvedYear} 
                                    name="approvedYear" 
                                    label="Gått et godkjent år på folkehøgskole" 
                                    onChange={this._onExtraPointsChackboxChange.bind(this)} 
                                />
                            </li>
                            <li>
                                <Checkbox 
                                    value="1" 
                                    checked={!!additionalPoints.haCredits60} 
                                    name="haCredits60" 
                                    label="60 studiepoeng fra høyere utdanning" 
                                    onChange={this._onExtraPointsChackboxChange.bind(this)} 
                                />
                            </li>
                            <li>
                                <Checkbox 
                                    value="1" 
                                    checked={!!additionalPoints.haCredits3059} 
                                    name="haCredits3059" 
                                    label="30-59 studiepoeng fra høyere utdanning" 
                                    onChange={this._onExtraPointsChackboxChange.bind(this)} 
                                />
                            </li>
                        </ul>
                    </ExtraPoints>
                </Main>

                <Aside>
                    <InfoCard title="Hva er alders- og tilleggspoeng?">
                        Du får 2 tilleggspoeng for enten folkehøgskole, militærtjeneste, siviltjeneste eller høyere utdanning. Du kan ikke få mer enn 2 tilleggspoeng. Selv om du har en bachelor tilsvarende 180 studiepoeng, får du fortsatt maks 2 tilleggspoeng. Du får 2 alderspoeng for hvert år fra året du fyller 20. Maks antall alderspoeng du kan få er 8.
                    </InfoCard>
                </Aside>

            </Wrapper>  
        );
    }
}

const mapStateToProps = state => ({
    yearBorn: state.calculator.yearBorn,
    additionalPoints: state.calculator.additionalPoints
})

const actions = {
    setCalculatorYearBorn,
    setCalculatorAdditionalPoints,
}

export default connect(mapStateToProps, actions)(AditionalPoints);

/*
|--------------------------------------------------------------------------
|  Styles
|--------------------------------------------------------------------------
*/
const Wrapper = styled.div`
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
`

const Main = styled.main`
    width:50%;
    .year-select {
        > div {
            width: 300px;
            justify-content: flex-start;
            padding-left: 15px;
        }
    }
    @media(max-width: 767px) {
        width:100%;
        order:2;
    }
    @media(max-width: 480px) {
        .year-select > div {
            width: 100%;
        }
    }
`

const Aside = styled.aside`
    width:50%;
    @media(max-width: 767px) {
        width:100%;
        order:1;
        margin-bottom:30px;
        > div {
            max-width:100%;
        }
    }
`

const Intro = styled.div`
    margin-bottom: 20px;
    h2 {
        margin-bottom: 20px;
    }
`

const ExtraPoints = styled.div`
    padding: 90px 0 55px;
    @media(max-width: 767px) {
        padding: 50px 0 30px;
    }
    ul {
        li {
            position:relative;
            margin-bottom:15px;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/Calculator/AditionalPoints.js